import styled from 'styled-components';
import FiduciaLogo from '../../../../../../../../../assets/images/fiducia-logo.jpg';

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #606060;
  margin: 0 0 40px 0;
  height: 100px;
  width: 100%;
`;

export const Logo = styled.div`
  background-image: url(${FiduciaLogo});
  background-repeat: no-repeat;
  background-size: contain;
  width: 350px;
  height: 100%;
`;

export const MainTitle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: bolder;
  width: 350px;
  height: 100%;
  font-size: 35px;
`;

export const PartnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  height: 100px;
`;

export const PartnerAndTotalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
`;

export const PartnerTitle = styled.h2`
  font-size: 30px;
`;

export const PartnerLabel = styled.h2`
  font-size: 30px;
  margin: 0 20px 0 0;
`;

export const TotolTitle = styled.h2`
  font-size: 30px;
`;

export const TotalLabel = styled.h2`
  font-size: 30px;
  margin: 0 20px 0 0;
`;

export const Table = styled.table`
  width: 100%;
`;

export const Row = styled.tr`
  font-size: 12px;
  padding: 4px;
  border-bottom: 1px solid #606060;
`;
export const Column = styled.th`
  padding: 4px;
`;

export const Data = styled.td`
  padding: 4px;
`;

export const Page = styled.div`
  @media all {
    .page-break {
      display: none;
    }
  }

  @media print {
    html,
    body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }

  @media print {
    .page-break {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
    }
  }

  @page {
    size: auto;
    margin: 10mm;
  }
`;
